import dayjs from '@/utils/dayjs';
import axios from "../../config/axiosConfig";
import {
  LEDGER_REPORT_REQUEST,
  LEDGER_REPORT_FAILURE,
  LEDGER_BY_PARTY_REPORT_FAILURE,
  SET_LEDGER_PARTIES,
  SET_LEDGER_BY_PARTY,
  SET_TRIAL_BALANCE_SCHEDULE_PARTIES,
  SET_TRADING_ACCOUNT_PARTIES,
  SET_PROFIT_LOSS_ACCOUNT,
  SET_BALANCE_SHEET,
  LEDGER_BY_PARTY_REPORT_REQUEST,
  UPDATE_LEDGER_STATUS_REQUEST,
  UPDATE_LEDGER_STATUS,
  UPDATE_LEDGER_STATUS_FAILURE,
  SET_LEDGER_BY_SCHEDULE,
  LEDGER_REPORT_SCHEDULE_REQUEST,
  LEDGER_REPORT_REQUEST_FAILURE,
  LEDGER_REPORT_REQUEST_SUCCESS
} from "../types/ledger-report-types";

export const getLedgerPartyList = (params) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({ type: LEDGER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };    
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/ledger-report/getPartyList?${queryString}`;
      const fullUrlWithTotal = `/ledger-report/getPartyListWithTotal?${queryString}`;

      // console.log('API Request URL: ', fullUrl);
      // axios.get(fullUrl).then((response) => {
      //   console.log('API Response Data-1: ', response);
      //   if (response.data) {
      //     dispatch({ type: SET_LEDGER_PARTIES, payload: response.data });
      //   }
      // }).catch((error) => {
      //   console.error("Error fetching Ledger Parties:", error);
      //   dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
      // });;
      
      // return axios.get(fullUrlWithTotal).then((res) => {
      //   console.log('API Response Data-2: ', res);
      //   return res.data;
      //   if (res.data) {
      //     dispatch({ type: SET_LEDGER_PARTIES, payload: res.data });
      //   }
      // }).catch((error) => {
      //   console.error("Error fetching Ledger Parties With Total:", error);
      //   dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
      // });
      return await axios.get(fullUrlWithTotal);
      // return await axios.get(fullUrl);
    } catch (error) {
      console.error("Error fetching Ledger Parties:", error);
      throw error;
      // dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getLedgerDataByParty = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_BY_PARTY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: auth.finyear?.From_Date,
        commanMaster: auth.company?.Common_Master
      };
    
      const requestParams = {
        ...defaultParams,
        ...params,
        fromDate: params.fromDate,
        toDate: params.toDate,
        accountId: params.accountId,
      };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/ledger-report/getLedgerByParty?${queryString}`;

      axios.get(fullUrl).then((response) => {
        if (response.data) {
          dispatch({ type: SET_LEDGER_BY_PARTY, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Ledger Report by Party:", error);
        dispatch({ type: LEDGER_BY_PARTY_REPORT_FAILURE, error: error.message });
      });  

    } catch (error) {
      console.error("Error fetching Ledger Report by Party:", error);
      dispatch({ type: LEDGER_BY_PARTY_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getClosingBalanceOfPartyForBankReceipt = (params) => {
  return async (dispatch, getState) => {
    try {
      // dispatch({ type: LEDGER_BY_PARTY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: auth.finyear?.From_Date && dayjs(auth.finyear?.From_Date).format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };
      console.log('params', params);
    
      const requestParams = {
        ...defaultParams,
        ...params,
        fromDate: params.fromDate && dayjs(params.fromDate).format('YYYY-MM-DD'),
        toDate: params.toDate && dayjs(params.toDate).format('YYYY-MM-DD'),
        accountId: params.accountId,
      };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/ledger-report/getClosingBalanceOfPartyForBankReceipt?${queryString}`;

      console.log('<<API Request URL:', fullUrl);

      // ✅ RETURN THIS
      const response = await axios.get(fullUrl);

      console.log('<<API Response Data:', response);

      return response.data; // ✅ this goes back to dispatch().then()

    } catch (error) {
      console.error("Error fetching Closing Balance of Party for Bank Receipt:", error);
      dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getLedgerData = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_REPORT_SCHEDULE_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: auth.finyear?.From_Date,
        commanMaster: auth.company?.Common_Master
      };
      console.log('params', params);
    
      const requestParams = {
        ...defaultParams,
        ...params,
        fromDate: params.fromDate,
        toDate: params.toDate,
      };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/ledger-report/getLedgerData?${queryString}`;

      console.log('API Request URL: ', fullUrl);
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: SET_LEDGER_BY_SCHEDULE, payload: response.data });
          console.log('response>>', response);
          
          return response;
        }
      }).catch((error) => {
        console.error("Error fetching Ledger Report by Party:", error);
        dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
      });  

    } catch (error) {
      console.error("Error fetching Ledger Report by Party:", error);
      dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const updateLedgerStatus = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_LEDGER_STATUS_REQUEST });

      const { refId, refType, isChecked } = params;

      if (!refId || !refType) {
        console.error("refId & refType required");
        return;
      }

      const queryString = new URLSearchParams({
        refId,
        refType
      }).toString();

      const fullUrl = `/ledger-report/updateLedgerStatus?${queryString}`;

      console.log("API Request URL:", fullUrl);

      // 🔥 Send PUT request with body
      const response = await axios.put(fullUrl, { isChecked });

      console.log("API Response:", response.data);

      dispatch({
        type: UPDATE_LEDGER_STATUS,
        payload: response.data
      });

    } catch (error) {
      console.error("Error updating ledger status:", error);
      dispatch({
        type: UPDATE_LEDGER_STATUS_FAILURE,
        error: error.message
      });
    }
  };
};

export const clearLedgerDataByParty = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LEDGER_BY_PARTY, payload: {} });
  }
}

export const getTrialBalanceSchedulePartyList = (params) => {
  return (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };    
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrlWithTotal = `/ledger-report/getTrialBalanceScheduleWithTotal?${queryString}`;

      console.log('API Request URL: ', fullUrlWithTotal);
      
      axios.get(fullUrlWithTotal).then((res) => {
        console.log('API Response Data-2: ', res);
        if (res.data) {
          dispatch({ type: SET_TRIAL_BALANCE_SCHEDULE_PARTIES, payload: res.data?.data });
        }
      }).catch((error) => {
        console.error("Error fetching Trial Balance(Schedule):", error);
        dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Trial Balance(Schedule):", error);
      dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getTradingAccountReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };    
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/ledger-report/getTradingAccount?${queryString}`;

      console.log('API Request URL: ', fullUrl);
      
      return axios.get(fullUrl).then((res) => {
        console.log('API Response Data: ', res);
        if (res.data) {
          dispatch({ type: SET_TRADING_ACCOUNT_PARTIES, payload: res.data });
          return res.data;
        }
      }).catch((error) => {
        console.error("Error fetching Trading Account:", error);
        dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
        return error;
      });
    } catch (error) {
      console.error("Error fetching Trading AccountParties:", error);
      dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getProfitLossAccountReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };    
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/ledger-report/getProfitLossAccount?${queryString}`;

      console.log('API Request URL: ', fullUrl);
      
      return axios.get(fullUrl).then((res) => {
        console.log('API Response Data: ', res);
        if (res.data) {
          dispatch({ type: SET_PROFIT_LOSS_ACCOUNT, payload: res.data });
        }
        return res.data;
      }).catch((error) => {
        console.error("Error fetching Trading Account:", error);
        dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
        return error;
      });
    } catch (error) {
      console.error("Error fetching Trading AccountParties:", error);
      dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getBalanceSheetReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        fromDate: dayjs(auth.finyear?.From_Date)?.format('YYYY-MM-DD'),
        toDate: dayjs(auth.finyear?.To_Date)?.format('YYYY-MM-DD'),
        commanMaster: auth.company?.Common_Master
      };    
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/ledger-report/getBalanceSheet?${queryString}`;

      console.log('API Request URL: ', fullUrl);
      
      return axios.get(fullUrl).then((res) => {
        console.log('API Response Data: ', res);
        if (res.data) {
          dispatch({ type: SET_BALANCE_SHEET, payload: res.data });
        }
        return res.data;
      }).catch((error) => {
        console.error("Error fetching Trading Account:", error);
        dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
        return error;
      });
    } catch (error) {
      console.error("Error fetching Trading AccountParties:", error);
      dispatch({ type: LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const sendMailLedger = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_REPORT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('accountId', mailData.accountId);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `ledger.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/ledger-report/ledger-mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: LEDGER_REPORT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: LEDGER_REPORT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: LEDGER_REPORT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappLedger = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LEDGER_REPORT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('accountId', whatsappData.accountId);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `ledger.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/ledger-report/ledger-whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: LEDGER_REPORT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: LEDGER_REPORT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: LEDGER_REPORT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const getOutstandingByPartyForLedger = (accountId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
    
      const params = {
        companyId: auth.company?.id,
        accountId: accountId,
      };

      return axios.get(`/ledger-report/get-outstanding-by-party`, { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error("Error fetching Ledger Report by Party:", error);
        throw error;
      });  

    } catch (error) {
      console.error("Error fetching Ledger Report by Party:", error);
      throw error;
    }
  };
};

export const closeBillFromLedgerOutstanding = (type, id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();

      return await axios.post("/ledger-report/close-unAdj-bill", { id, type }, { params: { userId: auth.user?.id } });

    } catch (error) {
      console.error("Error in close bill:", error);
      throw error;
    }
  };
}

export const updateLedgerOsStatus = (refType, refId, isChecked) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();

      return await axios.post("/ledger-report/update-outstanding-status", { refId, refType, isChecked }, { params: { userId: auth.user?.id } });

    } catch (error) {
      console.error("Error in outstanding status update:", error);
      throw error;
    }
  };
}

// export const updateLedgerOsStatus = (params) => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: UPDATE_LEDGER_STATUS_REQUEST });
//       const { refId, refType, isChecked } = params;
//       if (!refId || !refType) {
//         console.error("refId & refType required");
//         return;
//       }
//       const queryString = new URLSearchParams({
//         refId,
//         refType
//       }).toString();
//       const fullUrl = `/ledger-report/updateLedgerOsStatus?${queryString}`;
//       console.log("API Request URL:", fullUrl);
//       // 🔥 Send PUT request with body
//       const response = await axios.put(fullUrl, { isChecked });
//       console.log("API Response:", response.data);
//       dispatch({
//         type: UPDATE_LEDGER_STATUS,
//         payload: response.data
//       });

//     } catch (error) {
//       console.error("Error updating ledger status:", error);
//       dispatch({
//         type: UPDATE_LEDGER_STATUS_FAILURE,
//         error: error.message
//       });
//     }
//   };
// };